module.exports = __webpack_public_path__ + "static/media/lato-bold.0b318cfe.woff";